import { IMinimizedCourseItem } from '@/interfaces/course.interface';
import CoursePaymentCard, {
  CoursePaymentCardSkeleton,
} from 'design-system/components/Cards/PaymentCard/Course/CoursePaymentCard';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ComponentPropsWithoutRef } from 'react-markdown/lib/ast-to-react';
import { twMerge } from 'tailwind-merge';
import { TExtendCoursesGallery } from '../../type';

interface IDisplayCoursesGalleryDesktopProps
  extends ComponentPropsWithoutRef<'div'>,
    TExtendCoursesGallery<IMinimizedCourseItem> {}

const DisplayCoursesGalleryDesktop = ({
  query,
  urlGenerator,
  ...props
}: IDisplayCoursesGalleryDesktopProps) => {
  const {
    isLoading,
    data,
    hasNextPage,
    isFetching,
    fetchNextPage,
    isFetchingNextPage,
  } = query;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [inView, inView, hasNextPage, isFetching, fetchNextPage]);

  return (
    <>
      {isLoading ? (
        <div
          {...props}
          className={twMerge(
            'grid grid-cols-1 gap-4 lg:grid-cols-3 2xl:grid-cols-4',
            'justify-center',
            props.className
          )}
        >
          {new Array(4).fill(0).map((item, index) => (
            <CoursePaymentCardSkeleton
              key={index}
              className="w-auto shadow-none"
              placement={'Slider'}
            />
          ))}
        </div>
      ) : (
        <div
          {...props}
          className={twMerge(
            'grid grid-cols-1 gap-4 lg:grid-cols-3 2xl:grid-cols-4',
            (data?.pages.length || 0) >= 4 && 'justify-center',
            props.className
          )}
        >
          {data?.pages.map((item, index) => (
            <CoursePaymentCard
              key={index}
              className="h-full w-auto shadow-none"
              placement={'Slider'}
              dataContext={{
                courseId: item.id,
                url: urlGenerator(item),
                thumbnail: item.thumbnail,
                title: item.title,
                certificateShortName: item.certificateShortName,
                price: item.coursePrice?.isPaid
                  ? item.coursePrice?.price
                  : null,
                owner: {
                  fullName: item?.owner?.name,
                  academicRank: item?.owner?.academicRank,
                  avatar: item?.owner?.avatar,
                  url: item.owner?.profileUrl,
                },
              }}
            />
          ))}

          {isFetchingNextPage ? (
            new Array(4)
              .fill(0)
              .map((item, index) => (
                <CoursePaymentCardSkeleton
                  key={index}
                  className="w-auto shadow-none"
                  placement={'Slider'}
                />
              ))
          ) : (
            <div ref={hasNextPage ? ref : undefined}></div>
          )}
        </div>
      )}
    </>
  );
};

export default DisplayCoursesGalleryDesktop;
